import DividerLine from "components/common/divider/line";
import SkeletonBlock, { SkeletonCircle } from "..";
import { Forward } from "components/common/Icons";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";

export const ListItemSkeleton = () => {
  return (
    <div className={`flex gap-4 items-center`}>
      <div className="shrink-0">
        <SkeletonBlock width={40} height={40} radius={"100%"} />
      </div>
      <div className="flex grow gap-3">
        <SkeletonBlock width={"100%"} height={40} radius={10} />
        <SkeletonBlock width={"70%"} height={40} radius={10} />
      </div>
    </div>
  );
};

//
export const PortfolioMainSkeleton = () => {
  return (
    <div className="flex flex-col p-6 min-w-[360px] gap-3 ">
      {[1, 2].map((_, index: number) => {
        return (
          <div
            className="flex items-center  justify-between gap-3 py-5  bg-white p-5 rounded-[24px]"
            key={index}
          >
            <div className="flex flex-col gap-2 grow truncate">
              <SkeletonBlock width={109} height={46} />
              <SkeletonBlock width={175} height={46} />
            </div>
            <div>
              <SkeletonCircle />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const PortfolioDetailSkeleton = () => {
  return (
    <div className="bg-white flex flex-col w-full">
      <div className="flex flex-col gap-6 pb-2">
        <div className="flex flex-col gap-3 px-6 pt-[30px]">
          <div className=" flex justify-between">
            <div className="flex flex-col gap-1">
              <SkeletonBlock width={60} height={30} radius={5} />
              <SkeletonBlock width={175} height={35} radius={10} />
              <SkeletonBlock width={175} height={28} radius={10} />
            </div>
            <SkeletonCircle />
          </div>
          <SkeletonBlock width={109} height={40} radius={10} />
        </div>
        <div className="py-3 px-6">
          <div className="w-full">
            <SkeletonBlock width={"100%"} height={25} radius={10} />
          </div>
        </div>
      </div>
      <DividerLine size="md" />
      <div className="flex flex-col min-h-[200px] pb-5">
        <div className="flex px-6 pt-6 items-center gap-6">
          <SkeletonBlock width={"100%"} height={50} radius={10} />
          <SkeletonBlock width={"100%"} height={50} radius={10} />
          <SkeletonBlock width={"100%"} height={50} radius={10} />
        </div>
        <div className={`px-6 pt-6`}>
          <SkeletonBlock width={60} height={30} radius={10} />
        </div>
        <div className={`px-6 pt-4 flex justify-between`}>
          <SkeletonBlock width={90} height={30} radius={10} />
          <SkeletonBlock width={120} height={30} radius={10} />
        </div>
        <div className={`px-6 pt-4 flex flex-col`}>
          <SkeletonBlock width={"100%"} height={30} radius={10} />
          <div className="flex flex-col pt-6 gap-3">
            <SkeletonBlock width={45} height={20} radius={10} />
            <ListItemSkeleton />
            <ListItemSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
};

export const PortfolioRiskContentsSkeleton = () => {
  return (
    <div className="bg-white w-full flex flex-col pb-4">
      <div className="bg-gray5 flex justify-center items-center w-full pt-6">
        <div className="px-5 w-full">
          <div className="bg-white rounded-[20px] px-5 py-4 flex justify-between w-full">
            <div className="flex flex-col gap-3 w-[170px]">
              <SkeletonBlock width={170} height={50} radius={10} />
              <SkeletonBlock width={100} height={35} radius={10} />
            </div>
            <div>
              <SkeletonCircle />
            </div>
          </div>
        </div>
      </div>
      <div
        className="h-[24px]"
        style={{
          background: `linear-gradient(180deg, ${TAILWIND_TO_CSS["gray5"]} 0%, #FFF 100%)`,
        }}
      ></div>
      <div className="flex flex-col pt-6 px-6">
        <SkeletonBlock width={170} height={60} radius={10} />
      </div>
      <div className={`p-6 flex gap-[2px]`}>
        <SkeletonBlock width={"100%"} height={30} radius={"10px 0 0 10px"} />
        <SkeletonBlock width={"70%"} height={30} radius={0} />
        <SkeletonBlock width={"40%"} height={30} radius={"0 10px 10px 0"} />
      </div>
      <div className={`py-2 flex flex-col gap-4`}>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-4 px-6">
            <SkeletonBlock width={100} height={20} />
            <div className={`flex flex-col gap-4`}>
              <ListItemSkeleton />
              <ListItemSkeleton />
              <ListItemSkeleton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PortfolioRiskListSkeleton = () => {
  return (
    <div className="bg-white flex flex-col gap-5 mt-4  pb-4">
      <div className="px-6">
        <SkeletonBlock width={170} height={30} radius={10} />
      </div>
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-4 px-6">
          <SkeletonBlock width={100} height={20} />
          <div className={`flex flex-col gap-4`}>
            <ListItemSkeleton />
            <ListItemSkeleton />
            <ListItemSkeleton />
          </div>
        </div>
        <div className="flex flex-col gap-4 px-6">
          <SkeletonBlock width={100} height={20} />
          <div className={`flex flex-col gap-4`}>
            <ListItemSkeleton />
            <ListItemSkeleton />
            <ListItemSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
};

export const PortfolioAssetContentsSkeleton = () => {
  return (
    <div className="bg-white w-full flex flex-col pb-4">
      <div className="p-6 flex flex-col">
        <div className="flex flex-col gap-1 py-2">
          <SkeletonBlock width={50} height={30} radius={10} />
          <SkeletonBlock width={150} height={40} radius={10} />
        </div>
        <div className="flex flex-col gap-2 py-2">
          <SkeletonBlock width={"100%"} height={22} radius={10} />
          <SkeletonBlock width={"100%"} height={22} radius={10} />
          <SkeletonBlock width={"100%"} height={22} radius={10} />
        </div>
        <div className="flex gap-3 items-center pt-2">
          <SkeletonBlock width={24} height={24} radius={8} />
          <SkeletonBlock width={"100%"} height={24} radius={10} />
          <Forward fill={"gray30"} height={16} width={16} />
        </div>
      </div>
      <DividerLine size="md" />
      <div className={`px-6 pt-6`}>
        <SkeletonBlock width={60} height={30} radius={10} />
      </div>
      <div className={`px-6 pt-4 flex justify-between`}>
        <SkeletonBlock width={90} height={30} radius={10} />
        <SkeletonBlock width={120} height={30} radius={10} />
      </div>
      <div className={`px-6 pt-4 flex flex-col`}>
        <SkeletonBlock width={"100%"} height={30} radius={10} />
        <div className="flex flex-col pt-6 gap-3">
          <SkeletonBlock width={45} height={20} radius={10} />
          <ListItemSkeleton />
          <ListItemSkeleton />
          <ListItemSkeleton />
          <ListItemSkeleton />
        </div>
      </div>
    </div>
  );
};

export const PortfolioWeightContentsSkeleton = () => {
  const List = () => {
    return (
      <div className="flex gap-4">
        <div className="shrink-0">
          <SkeletonBlock width={24} height={24} radius={"100%"} />
        </div>
        <SkeletonBlock width={"100%"} height={24} radius={10} />
        <SkeletonBlock width={44} height={24} radius={10} />
      </div>
    );
  };
  return (
    <div className="bg-white w-full flex flex-col pb-4 px-6 gap-5">
      <div className="py-6 flex gap-[2px]">
        <SkeletonBlock width={"100%"} height={30} radius={"10px 0 0 10px"} />
        <SkeletonBlock width={"70%"} height={30} radius={0} />
        <SkeletonBlock width={"40%"} height={30} radius={"0 10px 10px 0"} />
      </div>
      <div className="py-2 gap-4 flex flex-col">
        <List />
        <List />
        <List />
        <List />
      </div>
    </div>
  );
};

export const PortfolioCompareSkeleton = () => {
  return (
    <div className="bg-white w-full flex flex-col pb-4">
      <div className="bg-white flex flex-col gap-[30px] pb-6">
        <div className="flex flex-col gap-2 pt-[30px] px-6 w-full">
          <SkeletonBlock width={40} height={24} radius={10} />
          <SkeletonBlock width={200} height={56} radius={10} />
        </div>
        <div className="flex flex-col gap-4 px-6">
          <div className="flex items-center gap-4">
            <SkeletonBlock width={40} height={24} radius={10} />
            <SkeletonBlock width={"100%"} height={40} radius={10} />
          </div>
          <div className="flex items-center gap-4">
            <SkeletonBlock width={40} height={24} radius={10} />
            <SkeletonBlock width={"100%"} height={40} radius={10} />
          </div>
        </div>
      </div>
      <DividerLine size="md" />
      <div className="px-6 pt-6">
        <SkeletonBlock width={200} height={28} radius={10} />
      </div>
      <div className="mt-6 py-2 flex flex-col gap-5 px-6">
        <ListItemSkeleton />
        <ListItemSkeleton />
        <ListItemSkeleton />
        <ListItemSkeleton />
        <ListItemSkeleton />
      </div>
    </div>
  );
};

export const PortfolioSharpeSkeleton = () => {
  return (
    <div className="bg-white w-full flex flex-col pb-4">
      <div className="px-6 pt-6 flex flex-col gap-1">
        <SkeletonBlock width={"100%"} height={28} radius={10} />
        <SkeletonBlock width={"100%"} height={28} radius={10} />
      </div>
      <div className="px-6 py-4 flex flex-col gap-2">
        <SkeletonBlock width={"100%"} height={108} radius={10} />
        <SkeletonBlock width={"100%"} height={108} radius={10} />
      </div>
      <div className="px-6 pt-6 flex flex-col gap-2">
        <SkeletonBlock width={"100%"} height={26} radius={10} />
        <SkeletonBlock width={"100%"} height={26} radius={10} />
        <SkeletonBlock width={"100%"} height={26} radius={10} />
      </div>
      <div className="mt-6 px-6 py-4 flex flex-col gap-2">
        <SkeletonBlock width={"100%"} height={170} radius={10} />
      </div>
    </div>
  );
};

export const PortfolioSettingSkeleton = () => {
  return (
    <div className="bg-white w-full flex flex-col px-6">
      <div className="py-6 flex flex-col  gap-6 justify-center w-full">
        <div className="flex flex-col  w-full gap-2">
          <div className="py-2 flex gap-3 items-center">
            <SkeletonBlock width={"100%"} height={45} radius={10} />
            <SkeletonBlock width={60} height={26} radius={10} />
            <SkeletonBlock width={60} height={26} radius={10} />
          </div>
          <div className="py-2 flex gap-3 items-center">
            <SkeletonBlock width={"100%"} height={45} radius={10} />
            <SkeletonBlock width={60} height={26} radius={10} />
            <SkeletonBlock width={60} height={26} radius={10} />
          </div>
          <div className="py-2 flex gap-3 items-center">
            <SkeletonBlock width={"100%"} height={45} radius={10} />
            <SkeletonBlock width={60} height={26} radius={10} />
            <SkeletonBlock width={60} height={26} radius={10} />
          </div>
        </div>
      </div>
    </div>
  );
};
